if (!customElements.get('bundle-picker')) {
  class BundlePicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
      this.inputsContainer = this.querySelector('[data-bundle-inputs]');
      this.currentVariantId = Number(this.dataset.variantId);

      try {
        this.formatter = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
          currencyDisplay: 'narrowSymbol',
        });
      } catch {
        this.formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.dataset.currency });
      }

      this.addEventListener('change', (event) => {
        if (event.target.matches('.bundle-picker__radio, [data-bundle-select]')) this.update();
      });

      // Keep pillow #1 in step with the swatch picker above
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data?.sectionId !== this.dataset.section || !data.variant) return;
          this.currentVariantId = data.variant.id;
          this.querySelectorAll('[data-bundle-colors]').forEach((colors) => {
            const first = colors.querySelector('[data-bundle-select]');
            if (first && !first.querySelector(`option[value="${data.variant.id}"]`)?.disabled) {
              first.value = String(data.variant.id);
            }
          });
          this.update();
        });
      }

      this.update();
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }

    variant(id) {
      return this.variants.find((variant) => variant.id === Number(id));
    }

    money(cents) {
      return this.formatter.format(cents / 100);
    }

    update() {
      let selectedIds = [];

      this.querySelectorAll('[data-bundle-option]').forEach((option) => {
        const radio = option.querySelector('.bundle-picker__radio');
        const colors = option.querySelector('[data-bundle-colors]');
        const selects = colors ? [...colors.querySelectorAll('[data-bundle-select]')] : [];
        const isSelected = radio.checked;

        option.classList.toggle('is-selected', isSelected);
        if (colors) colors.hidden = !isSelected;
        selects.forEach((select) => (select.disabled = !isSelected));

        const quantity = Number(radio.value);
        const ids = selects.length ? selects.map((select) => Number(select.value)) : Array(quantity).fill(this.currentVariantId);
        const discount = Number(radio.dataset.discount) || 0;
        const variants = ids.map((id) => this.variant(id)).filter(Boolean);
        const gross = variants.reduce((sum, variant) => sum + variant.price, 0);
        const price = Math.round((gross * (100 - discount)) / 100);
        const compare = variants.reduce((sum, variant) => sum + Math.max(variant.compare, variant.price), 0);
        const save = compare - price;

        option.querySelector('[data-bundle-price]').textContent = this.money(price);
        const compareEl = option.querySelector('[data-bundle-compare]');
        compareEl.textContent = this.money(compare);
        compareEl.hidden = save <= 0;
        const saveWrap = option.querySelector('.bundle-picker__save');
        saveWrap.hidden = save <= 0;
        option.querySelector('[data-bundle-save]').textContent = this.money(save);

        if (isSelected) selectedIds = quantity > 1 ? ids : [];
      });

      this.renderFormInputs(selectedIds);
    }

    // Multi-pillow tiers are sent as items[n][id] / items[n][quantity]; one pillow uses the normal form fields
    renderFormInputs(ids) {
      this.inputsContainer.replaceChildren();
      const counts = new Map();
      ids.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));

      [...counts.entries()].forEach(([id, quantity], index) => {
        [
          [`items[${index}][id]`, id],
          [`items[${index}][quantity]`, quantity],
        ].forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.setAttribute('form', this.dataset.productForm);
          this.inputsContainer.appendChild(input);
        });
      });
    }
  }

  customElements.define('bundle-picker', BundlePicker);
}
